import Dialog from './Dialog.vue'


Dialog.install = function (Vue) {
    const DialogConstructor = Vue.extend(Dialog)

    const instance = new DialogConstructor()

    instance.$mount(document.createElement("div"))

    document.body.appendChild(instance.$el)

    Vue.prototype.$dialog = (options = {}) => {
        instance.gateway = options.gateway
        instance.scene = options.scene
        instance.result = options.result
        instance.visible = true
    }
}


export default Dialog



// WEBPACK FOOTER //
// ./src/components/dialog/index.js